import React from 'react';
import {
  StyledErrorText,
  StyledImageContainer,
  StyledImageHeader,
  StyledImageHolder,
  StyledImageHolderContainer,
  StyledImageOverlay,
  StyledImageTitle
} from './ImageUploader.styles';
import ImagePlaceholder from './ImagePlaceholder.svg';
import { StyledTextButton } from '../../PlusWebsiteEditor.styles';
import { Button } from '@material-ui/core';

type Props = {
  title: string;
  url: string | null;
  className?: string;
  helperText?: string | null;
  accept?: string;
  onChangeClick?: () => void;
  onRemove?: () => void;
};

const DummyImageUploader = ({ className, helperText, title, url, onChangeClick, onRemove }: Props) => {
  return (
    <StyledImageContainer className={className}>
      <StyledImageHeader>
        <StyledImageTitle>{title}</StyledImageTitle>
        <StyledTextButton onClick={onChangeClick}>{url ? 'Change' : 'Upload'}</StyledTextButton>
      </StyledImageHeader>
      <StyledImageHolderContainer>
        <StyledImageHolder backgroundImage={url || ImagePlaceholder} />
        {onRemove && url && (
          <StyledImageOverlay>
            <Button onClick={onRemove} size="small" variant="contained">
              Remove
            </Button>
          </StyledImageOverlay>
        )}
      </StyledImageHolderContainer>
      {helperText && <StyledErrorText>{helperText}</StyledErrorText>}
    </StyledImageContainer>
  );
};
export default DummyImageUploader;
